export const isSectionRequiredForNextStatusesInApproving = (sectionName: string | undefined): boolean => {
  return !!sectionName && sectionsRequiredForNextStatusesInApproving.includes(sectionName);
};

export const sectionsRequiredForNextStatusesInApproving = ['approveInfo'];
